var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChronometer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 49,
    viewBox: "0 0 45 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7787_50999)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.5906,
    y: 6.39453,
    width: 6.3682,
    height: 3.1841,
    transform: "rotate(-7.31547 16.5906 6.39453)",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.0268,
    y: 3.64844,
    width: 12.7364,
    height: 3.1841,
    rx: 1.59205,
    transform: "rotate(-7.31547 13.0268 3.64844)",
    fill: "#5A34E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4073 42.2826C33.9834 41.0532 40.7502 32.2932 39.5208 22.717C38.2915 13.1408 29.5314 6.37409 19.9553 7.60345C10.3791 8.83281 3.61214 17.5913 4.8417 27.169C6.07107 36.7452 14.8311 43.5119 24.4073 42.2826Z",
    fill: "#5A34E1",
    stroke: "#3703A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9382 38.6296C31.4963 37.6593 36.8371 30.7454 35.8668 23.1873C34.8965 15.6292 27.9825 10.2884 20.4244 11.2587C12.8663 12.229 7.52544 19.1417 8.49588 26.7011C9.46617 34.2592 16.3801 39.5999 23.9382 38.6296Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8668 23.1873C36.3327 26.8169 35.3378 30.4829 33.1007 33.3789C30.8637 36.2749 27.5678 38.1637 23.9382 38.6296C20.3086 39.0956 16.6426 38.1006 13.7466 35.8636C10.8506 33.6265 8.96184 30.3307 8.49588 26.7011C8.02993 23.0715 9.02491 19.4054 11.2619 16.5094C13.499 13.6134 16.7948 11.7247 20.4244 11.2587C24.054 10.7928 27.7201 11.7877 30.6161 14.0248C33.5121 16.2618 35.4008 19.5577 35.8668 23.1873ZM25.0684 35.3932C25.0166 34.9899 24.8068 34.6237 24.485 34.3751C24.1632 34.1266 23.7559 34.016 23.3526 34.0678C22.9493 34.1196 22.5831 34.3294 22.3345 34.6512C22.086 34.973 21.9754 35.3803 22.0272 35.7836C22.079 36.1869 22.2888 36.5531 22.6106 36.8017C22.9324 37.0502 23.3397 37.1608 23.743 37.109C24.1463 37.0572 24.5125 36.8474 24.7611 36.5256C25.0096 36.2038 25.1202 35.7965 25.0684 35.3932ZM34.0957 22.7315C33.9848 22.5634 33.8419 22.4189 33.6751 22.306C33.5084 22.1932 33.3211 22.1144 33.1238 22.0739C32.7255 21.9923 32.3111 22.0723 31.9717 22.2962C31.6323 22.5202 31.3958 22.8697 31.3142 23.2681C31.2326 23.6664 31.3125 24.0808 31.5364 24.4202C31.7604 24.7596 32.11 24.9961 32.5083 25.0777C32.9066 25.1593 33.3211 25.0794 33.6604 24.8554C33.9998 24.6315 34.2363 24.2819 34.3179 23.8836C34.3996 23.4853 34.3196 23.0708 34.0957 22.7315ZM12.3737 27.5897C12.5482 27.4818 12.6993 27.34 12.818 27.1727C12.9368 27.0053 13.0207 26.8158 13.0648 26.6155C13.109 26.4151 13.1124 26.2079 13.075 26.0061C13.0376 25.8044 12.9601 25.6122 12.8471 25.441C12.734 25.2697 12.5878 25.1229 12.4169 25.0093C12.2461 24.8956 12.0542 24.8174 11.8526 24.7792C11.651 24.7411 11.4438 24.7438 11.2432 24.7873C11.0427 24.8307 10.8529 24.9139 10.6851 25.032C10.3591 25.2615 10.1354 25.609 10.0613 26.0007C9.98718 26.3924 10.0686 26.7976 10.2882 27.1303C10.5079 27.463 10.8485 27.697 11.2378 27.7828C11.6271 27.8686 12.0345 27.7993 12.3737 27.5897Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4289 26.8711C21.8499 26.9455 21.3075 26.472 21.2237 25.819L20.3092 18.6951C20.2253 18.0421 20.6305 17.447 21.2095 17.3727C21.7885 17.2983 22.3308 17.7718 22.4146 18.4248L23.3292 25.5487C23.4145 26.2136 23.0079 26.7968 22.4289 26.8711Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9965 26.555C21.7047 26.0495 21.9324 25.3665 22.5025 25.0373L28.7226 21.4462C29.2928 21.117 29.9981 21.2613 30.29 21.7668C30.5818 22.2724 30.3541 22.9553 29.784 23.2845L23.5639 26.8757C22.9834 27.2108 22.2884 27.0606 21.9965 26.555Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9123 15.475C21.3311 15.4212 21.7114 15.2033 21.9695 14.8691C22.2276 14.535 22.3424 14.112 22.2886 13.6932C22.2349 13.2744 22.0169 12.8941 21.6828 12.636C21.3486 12.3779 20.9256 12.263 20.5068 12.3168C20.088 12.3706 19.7077 12.5885 19.4496 12.9227C19.1915 13.2568 19.0767 13.6798 19.1305 14.0986C19.1842 14.5174 19.4021 14.8977 19.7363 15.1558C20.0705 15.414 20.4935 15.5288 20.9123 15.475Z",
    fill: "#F8312F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7787_50999",
    x: 0.197418,
    y: 0.214844,
    width: 43.9677,
    height: 48.7109,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7787_50999"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7787_50999",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChronometer);
export default __webpack_public_path__ + "static/media/chronometer.ccf98947e43c3ad27550b79a385c8aaf.svg";
export { ForwardRef as ReactComponent };